// extracted by mini-css-extract-plugin
module.exports = {"is-blurred":"BlurEffect_is-blurred__k2zSy","main-show":"BlurEffect_main-show__23kTs"};